// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"130":"39413481","270":"484b9c58","957":"4a1b32fa"}[chunkId] + ".css";
};